import { ContactPropertyVisibleResponse, } from '../dto/ResDtoRepository';
import { UpdateContactPropertyVisibleReq } from '../dto/ReqDtoRepository';
import { sendApiRequest, sendGetApiRequest } from './apiConfig';


export const getContactPropertyVisible = async (aui: string): Promise<ContactPropertyVisibleResponse> => {
  return sendGetApiRequest<ContactPropertyVisibleResponse>(`/api/v1/contact-property?aui=${aui}`);
};

export const updateContactPropertyVisible = async (aui: string, data: UpdateContactPropertyVisibleReq): Promise<ContactPropertyVisibleResponse> => {
  return sendApiRequest<ContactPropertyVisibleResponse>('put', `/api/v1/contact-property?aui=${aui}`, data);
};
